export const styles = theme => ({
    productSection: {
        marginBottom: 40,
    },
    sectionTitle: {
        backgroundColor: "#f5f5f5",
        "& h2": {
            fontSize: 20,
            padding: "16px 24px",
            margin: 0,
            color: "#009",
            fontWeight: "bold",
        },
        "& h4": {
            fontSize: 14,
            padding: "12px 12px 12px 24px",
            margin: 0,
            color: "#009",
            fontWeight: "bold",
        },
        "& img": {
            margin: "18px 11px 0 19px",
            width: 19,
            float: "left",
        },
        "& h5": {
            padding: "10px 24px",
            fontFamily: "Arial",
            fontSize: "0.8rem",
            margin: 0,
            color: "#009",
            fontWeight: "bold",
        },
        margin: "0 0 10px 0",
    },
    sectionDescription: {
        fontSize: 16,
        padding: 16,
        "& a": {
            textDecoration: "none",
        }
    },
    clickableIcon: {
        margin: "5px 0 0 10px",
        cursor: "pointer",
        "&:hover": {
            color: "#333",
        },
    }
});